<div class="p-grid">
	<div class="p-col-12 p-md-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1 h-100">
			<div class="d-flex flex-wrap">
				<div>
					<div class="d-flex">
						<span class="overview-icon">
							<fa-icon [icon]="['far', 'dollar-sign']"></fa-icon>
						</span>
						<span class="overview-title">
							<div class="d-flex">
								<div>Sales Total</div>
							</div>
						</span>
					</div>

					<div class="p-grid overview-detail">
						<div class="p-col-12">
							<ngx-charts-number-card [scheme]="colorScheme" [results]="numberChartData" [cardColor]="cardColor"> </ngx-charts-number-card>
							<span *ngIf="loading">
								<p-skeleton></p-skeleton>
							</span>
							<div class="overview-number">
								<span *ngIf="!loading">
									{{ salesSummary.NetSales | currency }}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div></div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-8">
		<div class="card no-gutter widget-overview-box widget-overview-box-2 h-100">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'dollar-sign']"></fa-icon>
				</span>
				<span class="overview-title">
					<div class="d-flex">
						<div>Comparison</div>
					</div>
				</span>
			</div>

			<div class="p-grid overview-detail">
				<div class="p-col-12">
					<span *ngIf="!loading">
						<ngx-charts-gauge
							[scheme]="colorScheme"
							[max]="chartMaxValue"
							[min]="0"
							[results]="gaugeChartData"
							[legend]="legend"
							[legendPosition]="legendPosition"
							[showText]="false"
						>
						</ngx-charts-gauge>
					</span>
					<span *ngIf="loading">
						<p-skeleton width="100%" height="150px"></p-skeleton>
					</span>
					<div class="overview-subtext">Compare today, last week, last year and average for the day</div>
				</div>
			</div>
		</div>
	</div>
</div>
